import * as Types from "../actions/action.types"
import * as Models from "../models/index"

export const defaultState = {
    userPwdValidationResult: [] as Models.ValidateUserPassword_Response_Client[],
    oldPwdValidationResult: {} as Models.ValidateUserPassword_Response_Client,
    matchingPwd: false as boolean,
    isNeededValidation: true as boolean
}

export type ReduserState = typeof defaultState;
export const reducer = (state = defaultState, action: any): ReduserState => {
    switch (action.type) {
        case Types.PWD_UPDATE_VALIDATION_USER_PASSWORD:
            return {
                ...state,
                userPwdValidationResult: action.payload,
            }
        case Types.PWD_UPDATE_MATCHING_PASSWORD_AND_CONFIRM:
            return {
                ...state,
                matchingPwd: action.payload
            }
        case Types.PWD_UPDATE_VALIDATION_OLD_PASSWORD:
            return {
                ...state,
                oldPwdValidationResult: action.payload
            }
        case Types.PWD_UPDATE_IS_NEEDED_VALIDATION:
            return {
                ...state,
                isNeededValidation: action.payload
            }
        case Types.PWD_SET_DEFAULT:
            return {
                ...state,
                userPwdValidationResult: [],
                oldPwdValidationResult: {
                    isPassed: false,
                    test: "Old password is correct"
                },
                matchingPwd: false
            }
        default:
            return state;
    }
}